import { useEffect, useMemo, useState } from "react";
import "./Navbar.css";
import logo from "../../assets/logo.png";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const items = useMemo(
    () => [
      { label: "Home", id: "#home" },
      { label: "About", id: "#about" },
      { label: "Services", id: "#services" },
      { label: "Process", id: "#process" },
      { label: "Contact", id: "#contact" },
    ],
    []
  );

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // close on ESC
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") setOpen(false);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  // lock body scroll when mobile menu is open
  useEffect(() => {
    if (!open) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, [open]);

  // close menu on resize to desktop
  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth > 860) setOpen(false);
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const go = (id) => {
    setOpen(false);
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header className={`nav ${scrolled ? "nav--scrolled" : ""} ${open ? "nav--open" : ""}`}>
      <div className="container nav__inner">
        <a
          className="nav__brand"
          href="#home"
          onClick={(e) => {
            e.preventDefault();
            go("#home");
          }}
        >
          <img className="nav__logo" src={logo} alt="Nesflix Digital" />
        </a>

        {/* Desktop links */}
        <nav className="nav__links" aria-label="Primary navigation">
          {items.map((x) => (
            <button key={x.id} type="button" className="nav__link" onClick={() => go(x.id)}>
              {x.label}
            </button>
          ))}

          <button type="button" className="btn btn-primary nav__cta" onClick={() => go("#contact")}>
            Get Proposal
          </button>
        </nav>

        {/* Burger */}
        <button
          type="button"
          className={`nav__burger ${open ? "is-open" : ""}`}
          onClick={() => setOpen((v) => !v)}
          aria-label="Menu"
          aria-expanded={open}
          aria-controls="nav-mobile"
        >
          <span />
          <span />
          <span />
        </button>
      </div>

      {/* Mobile drawer (fixed + animated) */}
      <div id="nav-mobile" className={`nav__mobile ${open ? "is-open" : ""}`} aria-hidden={!open}>
        <button
          type="button"
          className="nav__backdrop"
          aria-label="Close menu"
          onClick={() => setOpen(false)}
        />

        <div className="nav__panel">
          <div className="nav__panelInner">
            {items.map((x) => (
              <button key={x.id} type="button" className="nav__mLink" onClick={() => go(x.id)}>
                {x.label}
              </button>
            ))}

            <button type="button" className="btn btn-primary nav__mCta" onClick={() => go("#contact")}>
              Get Proposal
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}
